import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

function Block({ block, index }) {
  const layout = block.layout || "left";
  const dark = block.background === "dark";
  const alt = block.background === "alt";
  const bg = dark ? "bg-[#2C3531] text-[#FDFBF7]" : alt ? "bg-[#F3EFE7]" : "bg-[#FDFBF7]";

  const Text = (
    <div>
      {block.eyebrow && <p className="uppercase tracking-[0.2em] text-xs font-bold text-[#9A8C73] mb-4">{block.eyebrow}</p>}
      {block.heading && <h2 className={`font-display text-4xl md:text-5xl font-semibold mb-5 ${dark ? "text-[#FDFBF7]" : "text-[#1A201D]"}`}>{block.heading}</h2>}
      {block.body && <div className={`rte-content leading-relaxed ${dark ? "text-[#FDFBF7]/80" : "text-[#4A5550]"}`} dangerouslySetInnerHTML={{ __html: block.body }} />}
      {block.cta_label && (
        <Link to={block.cta_href || "#"} className={`inline-flex items-center gap-2 mt-7 px-7 py-3.5 rounded-full font-semibold hover:scale-105 transition-transform duration-300 ${dark ? "bg-[#9A8C73] text-white" : "bg-[#2C3531] text-[#FDFBF7]"}`}>
          {block.cta_label} <ArrowRight className="w-4 h-4" />
        </Link>
      )}
    </div>
  );
  const Img = block.image ? (
    <div className="overflow-hidden rounded-[2.5rem] shadow-[0_20px_60px_rgba(44,53,49,0.12)]">
      <img src={block.image} alt="" className="w-full h-[300px] md:h-[440px] object-cover" />
    </div>
  ) : null;

  return (
    <section className={`${bg} py-24`} data-testid={`custom-block-${index}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {layout === "full" || !block.image ? (
          <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="max-w-3xl">{Text}</motion.div>
        ) : (
          <div className={`grid lg:grid-cols-2 gap-14 items-center ${layout === "right" ? "" : ""}`}>
            <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className={layout === "right" ? "lg:order-2" : ""}>{Text}</motion.div>
            <motion.div initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} className={layout === "right" ? "lg:order-1" : ""}>{Img}</motion.div>
          </div>
        )}
      </div>
    </section>
  );
}

export default function CustomBlocks({ blocks }) {
  if (!blocks || blocks.length === 0) return null;
  return <>{blocks.map((b, i) => <Block key={b.id || i} block={b} index={i} />)}</>;
}
